import {createSlice} from '@reduxjs/toolkit';
import CryptoJS from 'crypto-js';

const localStore = (user, data) => {
  localStorage.removeItem(user);
  if (data.length !== 0) {
    const ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify({cart: data}),
      process.env.REACT_APP_CART_KEY
    ).toString();
    localStorage.setItem(user, JSON.stringify(ciphertext));
  }
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    products: [],
    callDB: true,
  },
  reducers: {
    addCart: (state, action) => {
      if (state.products.length < 1) {
        state.products = [...state.products, action.payload.data];
        state.callDB = true;
        localStore(action.payload.user, state.products);
      } else {
        let quantityUpdation = false;
        for (var i = 0; i < state.products.length; i++) {
          if (
            state.products[i].id === action.payload.data.id &&
            state.products[i].size === action.payload.data.size &&
            state.products[i].color === action.payload.data.color &&
            state.products[i].variant === action.payload.data.variant
          ) {
            state.products[i].quantity += action.payload.data.quantity;
            if (state.products[i].quantity > 15) {
              state.products[i].quantity = 15;
            }
            quantityUpdation = state.callDB = true;
            // state.callDB = true;
            localStore(action.payload.user, state.products);
          }
        }
        if (!quantityUpdation) {
          state.products = [...state.products, action.payload.data];
          state.callDB = true;
          localStore(action.payload.user, state.products);
        }
      }
    },
    updateCartQty: (state, action) => {
      state.products[action.payload.pos].quantity = action.payload.quantity;
      state.callDB = false;
      localStore(action.payload.user, state.products);
    },
    removeCart: (state, action) => {
      let newItems = state.products;
      newItems.splice(action.payload.pos, 1);
      state.products = newItems;
      state.callDB = true;
      localStore(action.payload.user, state.products);
    },
    cleanCart: (state, action) => {
      state.products = [];
      localStore(action.payload.user, state.products);
    },
  },
});

export const {
  addCart,
  updateCartQty,
  removeCart,
  cleanCart,
} = cartSlice.actions;

export const getCart = (state) => state.cart?.products;
export const callDBCart = (state) => state.cart.callDB;

export default cartSlice.reducer;
